import React, {useCallback, useEffect, useState} from 'react';
import {RouteComponentProps} from 'react-router-dom';
import ListHtml from "./html/ListHtml";
import QnaTopHtml from "./html/QnaTopHtml";
import SearchTopHtml from "./html/SearchTopHtml";
import {BoardSearch} from "../../model/BoardSearch";
import moment from "moment";
import CategoryHtml from "./html/CategoryHtml";
import * as queryString from "query-string";

const BoardList =
    (props: RouteComponentProps<{ id: string, category?: string }>) => {
        const match = props.match;
        const forumCode = match.params.id ?? 'notice';
        const categoryId = match.params.category ?? 0;
        const [categoryCode, setCategoryCode] = useState(categoryId);
        const location = props.location;
        const search = queryString.parse(location.search);
        let categoryNm = '홈';
        if (categoryId > 0) {
            if (search.ct) {
                categoryNm = search.ct.toString();
            }
        }

        const [param, setParam] = useState<BoardSearch>({});
        const searchFunc = (param: BoardSearch, callback: any) => {
            param.inx = moment().format('YYMMDDHHmmss');
            console.log(`parent search func read inx=${param.inx},categoryId=${param.categoryId}`);
            setParam(param);
            const categoryCode = param.categoryId ?? 0;
            setCategoryCode(categoryCode);
            callback();
        }
        let categoryHtml = null, writeBtn = null, searchHtml = null;
        const isSearchForm = useCallback((code: string) => {
            return code !== 'notice' && code !== 'global' && code.indexOf('qna')<0;
        }, []);

        console.log(`forumCode=${forumCode} categoryId=${categoryId} categoryNm=${categoryNm}`);
        const isHelp=forumCode==='help'|| forumCode==='qhelp';
        if (isHelp) {
            categoryHtml = <CategoryHtml forumCode={forumCode} categoryId={categoryId}/>;
        }
        if (forumCode.indexOf('qna')>=0) {
            writeBtn = <QnaTopHtml forumCode={forumCode}/>
        }
        if (isSearchForm(forumCode)) {
            searchHtml = <SearchTopHtml forumCode={forumCode} searchFunc={searchFunc}/>;
        }
        useEffect(() => {
            setCategoryCode(categoryId);
        }, [categoryId]);

        return (
            <>
                {writeBtn}
                {searchHtml}
                {categoryHtml}
                <div className="bloc l-bloc" id="bloc-0">
                    <div className="container bloc-sm">
                        <ListHtml forumCode={forumCode} param={param} categoryId={categoryCode}
                                  categoryNm={categoryNm}></ListHtml>
                    </div>
                </div>

            </>
        );
    };

export default BoardList;
